module.exports = __webpack_public_path__ + "img/item2.dc77a98e.png";